// Centralized config for lead status display: label, color, icon.
import { LeadStatus, DraftStatus } from "./types";

export interface StatusConfig {
  label: string;
  emoji?: string;
  // Tailwind classes — text + bg tinted for dark surfaces
  classes: string;
  short?: string;
}

export const LEAD_STATUS_CONFIG: Record<LeadStatus, StatusConfig> = {
  dm_new: {
    label: "Nouveau",
    emoji: "✨",
    classes: "bg-status-new/10 text-status-new ring-1 ring-status-new/20",
  },
  dm_active: {
    label: "Actif",
    emoji: "💬",
    classes: "bg-status-active/10 text-status-active ring-1 ring-status-active/20",
  },
  dm_qualifying: {
    label: "Qualif",
    emoji: "🔍",
    classes: "bg-status-qualifying/10 text-status-qualifying ring-1 ring-status-qualifying/20",
  },
  dm_qualified: {
    label: "Qualifié",
    emoji: "🔥",
    classes: "bg-status-qualified/10 text-status-qualified ring-1 ring-status-qualified/30",
  },
  dm_call_booked: {
    label: "Call booké",
    emoji: "📅",
    classes: "bg-status-booked/10 text-status-booked ring-1 ring-status-booked/30",
  },
  dm_disqualified: {
    label: "Disqualifié",
    emoji: "🚫",
    classes: "bg-status-disqualified/10 text-status-disqualified ring-1 ring-status-disqualified/20",
  },
  dm_cold: {
    label: "Cold",
    emoji: "🥶",
    classes: "bg-status-cold/10 text-status-cold ring-1 ring-status-cold/20",
  },
};

export const DRAFT_STATUS_CONFIG: Record<DraftStatus, StatusConfig> = {
  pending: {
    label: "Pending",
    emoji: "⏳",
    classes: "bg-accent-tint text-accent-400 ring-1 ring-accent-500/30",
  },
  sending: {
    label: "Envoi…",
    emoji: "📤",
    classes: "bg-accent-tint text-accent-400 ring-1 ring-accent-500/30",
  },
  sent: {
    label: "Envoyé",
    emoji: "✅",
    classes: "bg-success/10 text-success ring-1 ring-success/30",
  },
  edited: {
    label: "Édité + envoyé",
    emoji: "✏️",
    classes: "bg-warn/10 text-warn ring-1 ring-warn/30",
  },
  skipped: {
    label: "Skipped",
    emoji: "⏭️",
    classes: "bg-status-cold/10 text-status-cold ring-1 ring-status-cold/20",
  },
  disqualified: {
    label: "Disqualifié",
    emoji: "🚫",
    classes: "bg-status-disqualified/10 text-status-disqualified ring-1 ring-status-disqualified/20",
  },
};

export const PITCH_STAGE_LABELS: Record<string, string> = {
  opener: "Opener",
  dig: "Dig",
  objective: "Objectif",
  revenue: "Revenu",
  ads_probe: "Ads probe",
  pitch: "Pitch",
  objection: "Objection",
  nurture: "Nurture",
  call_pitch: "Call pitch",
  booking: "Booking",
  post_booking: "Post-booking",
  disqualif: "Disqualif",
};

export const PITCH_STAGE_ORDER: string[] = [
  "opener",
  "dig",
  "objective",
  "revenue",
  "ads_probe",
  "pitch",
  "objection",
  "nurture",
  "call_pitch",
  "booking",
];
